import { observer } from 'mobx-react';
import { InvitationResource } from '../../Store/Types';
import { MulticheckStore } from '../../../../../../Multicheck/Store';
import ModalStore from '../../../../../Modal/Store';
import InvitationStore from '../../Store/InvitationStore';
import Content from './Content';
import InactiveRow from './InactiveRow';

interface Props {
  store: InvitationStore;
  resource: InvitationResource;
  multicheckStore: MulticheckStore<InvitationResource>;
  modalStore: ModalStore;
}

function Row({ store, resource, modalStore, multicheckStore }: Props) {
  return (
    <InactiveRow invitationStatus={resource.payload.invitationStatus}>
      <Content
        store={store}
        resource={resource}
        multicheckStore={multicheckStore}
        modalStore={modalStore}
      />
    </InactiveRow>
  );
}

export default observer(Row);
